import React, { useState } from "react";
import "../../../css/Form.css";
import Popup from "../../../helper/SuccessPopup";
import AdditionalDetailsPage from "../AdditionalDetails/AdditionalDetailsPage";
import ERPUtils from "../../../helper/Utils";
import Loader from "../../../helper/Loader";
import ApiGateway from "../../../helper/ApiGateway";
import useStateCallback from "../../../helper/asyncSetState";
// import UnAvailableReasons from './UnavailableReasons';
import DatePicker from 'react-datepicker';

import Select from "react-select";
import $ from "jquery";
import Utils from "../../../helper/Utils";
import { toast } from "react-toastify";
// import moment from 'moment';

const SelectedForm = (props) => {
  const { selectedRoundData, ActiveInterviewRound, interviewDetails, closeInterviewModal, getApplicationsData } = props;
  //Loader:
  const [LoaderActive, setLoaderActive] = useStateCallback(false);
  //Error
  const [ErrorPopup, setErrorPopup] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState("");
  // Comp State:
  // const EducationStatus = [{ value: '1', label: 'Pursuing' }, { value: '2', label: 'Completed' }];
  const [countries, setCountries] = useStateCallback([]);
  const [states, setStates] = useStateCallback([]);
  const [MaritalOptions, setMartialOptions] = useStateCallback([]);
  const [ReasonsForRej, setReasonsForRej] = useStateCallback([]); // DropDown Data
  const [qualificationData, setQualificationData] = useStateCallback([]);
  const [SelectedFormState, setSelectedFormState] = useStateCallback({

    OfferLetterAcceptence:
      ERPUtils.isUndefinedOrNull(selectedRoundData) === false
        ? ERPUtils.isNullorWhiteSpace(selectedRoundData.isAcceptOffer) === false
          ? selectedRoundData.isAcceptOffer
          : ""
        : "", //selectedRoundData.isAcceptOffer

    confirmJoiningDate:
      ERPUtils.isUndefinedOrNull(selectedRoundData) === false
        ? ERPUtils.isNullorWhiteSpace(selectedRoundData.empJobDetailsDTO.isJoiningDateConfirmed) === false
          ? selectedRoundData.empJobDetailsDTO.isJoiningDateConfirmed : "" : "",
    RejectionReason: "",
    otherReason: "",
    ReportingDate:
      ERPUtils.isUndefinedOrNull(selectedRoundData.reportingDate) === false
        ? selectedRoundData.reportingDate.split(" ")[0] +
        " " +
        selectedRoundData.reportingDate.split(" ")[1] +
        " " +
        selectedRoundData.reportingDate.split(" ")[2]
        : "",
    JoiningDate:
      ERPUtils.isUndefinedOrNull(selectedRoundData.joiningDate) === false
        ? selectedRoundData.joiningDate.split(" ")[0] + " " + selectedRoundData.joiningDate.split(" ")[1] + " " + selectedRoundData.joiningDate.split(" ")[2]
        : "",
    preferedJoiningDateTime:
      ERPUtils.isUndefinedOrNull(selectedRoundData) === false
        ? ERPUtils.isNullorWhiteSpace(selectedRoundData.empJobDetailsDTO.preferedJoiningDateTime) === false
          ? selectedRoundData.empJobDetailsDTO.preferedJoiningDateTime : "" : "",
    joiningDateRejectReason:
      ERPUtils.isUndefinedOrNull(selectedRoundData) === false
        ? ERPUtils.isNullorWhiteSpace(selectedRoundData.empJobDetailsDTO.joiningDateRejectReason) === false
          ? selectedRoundData.empJobDetailsDTO.joiningDateRejectReason : "" : "",

    TermsAndConditions: "",

    AdditonalEducationDetails: {
      qualificationList: [],
      others: [],
    },
    PanNo: "",
    TwoWheelerNO: "",
    FourWheelerNo: "",
    UanNo: "",
    // PfNo: "",
    // PfDate: "",
    empJobDetailsDTO: {
      pfAccountNo: null,
      pfDate: null,
      gratuityNo: null,
      gratuityDate: null,

    },
    empGratuityNomineesDTO: [
      {
        empId: "",
        empJobDetailsId: "",
        empPfGratuityNomineesId: "",
        isGratuity: null,
        isPf: null,
        nominee: "",
        nomineeAddress: "",
        nomineesDob: "",
        nomineeRelationship: "",
        sharePercentage: "",
        under18GuardName: "",
        under18GuardianAddress: "",
      },
    ],
    empPfNomineesDTO: [
      {
        empId: "",
        empJobDetailsId: "",
        empPfGratuityNomineesId: "",
        isGratuity: null,
        isPf: null,
        nominee: "",
        nomineeAddress: "",
        nomineesDob: "",
        nomineeRelationship: "",
        sharePercentage: "",
        under18GuardName: "",
        under18GuardianAddress: "",
      },
    ],

    familyDetailsAddtnlList: [
    ],
    dependentDetailsAddtnlList: [
      {
        empFamilyDetailsAddtnlId: "",
        empApplnPersonalDataId: selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId,
        empPersonalDataId: "",
        relationship: "",
        dependentName: "",
        dependentDob: "",
        dependentQualification: "",
        dependentProfession: "",
        dependDOB: null,
      },
    ],
    haveAadhar: "",
    AadharNo: "",
    EnrolledForAadhar: "",
    EnrollmentId: "",

    EmgContactName: "",
    EmgContactAddress: "",
    EmgContactRelationship: "",
    EmgMobileNo: "",
    EmgHomeContact: "",
    EmgWorkContact: "",

    PassportNo: "",
    PassportIssuedDate: "",
    PassportStatus: "",
    PassportDateOfExpiry: "",
    PassportComments: "",
    visaNo: "",
    vissaIssuedDate: "",
    vissaStatus: "",
    visaDateOfExpiry: "",
    visaComments: "",

    MaritalStatus: selectedRoundData?.maritalStatusDTO || "",

    childrenDetails: [
      {
        name: "",
        dob: "",
        qualification: "",
        profession: "",
      },
    ],
    Dependents: [
      {
        name: "",
        dob: "",
        RelationAndReason: "",
      },
    ],
    familyBackgrounnd: "",
    AccountWithSib: "",
    AcctNO: "",
    ConfirmAcctNo: "",
    IfscCode: "",
  });

  // Popups:
  const [ValidationAlert, setValidationAlert] = useState(false);
  const [AccountErrorPopup, setAccountErrorPopup] = useState(false);
  const [RequiredFieldAlert, setRequiredFieldAlert] = useStateCallback(false);

  const [validationErrors, setvalidationErrors] = useStateCallback({
    EmgMobileNoError: false,
    EmgHomeContactError: false,
    EmgWorkContactError: false,
    AcctNOError: false,
    ConfirmAcctNoError: false,
    PfNoError: false,
  });
  const [acctNumError, setAcctNumError] = useStateCallback(false);
  const [RequiredFields, setRequiredFields] = useStateCallback({
    commonErrors: [
      {
        OfferLetterAcceptenceReqError: false,
        RejectionReasonReqError: false,
        otherReasonReqError: false,
        AcctNOReqError: false,
        IfscCodeReqError: false,
      },
    ],
  });

  // Save Draft Error Count:
  const addReqErrors = {
    tenth: [],
    puc: [],
    ug: [],
    pg: [],
    mphil: [],
    phd: [],
    others: [],
  };

  const ValidationErrorHandler = (name, removeError) => {
    let oldData = { ...validationErrors };
    let target = name;
    let comName = "Error";
    let stateName = target + comName;
    if (removeError) {
      oldData[stateName] = true;
    } else {
      oldData[stateName] = false;
    }
    setvalidationErrors(oldData);
  };

  // Handlers:
  const AlertError = () => {
    setErrorPopup(true);
  };

  const ErrorPopupHandler = () => {
    setErrorPopup(!ErrorPopup);
  };

  // const changeTheState = (data, target) => {
  // 	let newData = [];
  // 	if (target === 'tenth') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				TenthQualification: el.TenthQualification,
  // 				TenthStatus: el.TenthStatus,
  // 				TenthCourse: el.TenthCourse,
  // 				TenthSpecialization: el.TenthSpecialization,
  // 				TenthYearOfComp: el.TenthYearOfComp,
  // 				TenthPercentage: el.TenthPercentage,
  // 				TenthInstitute: el.TenthInstitute,
  // 				TenthBoard: el.TenthBoard,
  // 				TenthState: '',
  // 				TenthCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}
  // 	if (target === 'puc') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				PucQualification: el.PucQualification,
  // 				PucStatus: el.PucStatus,
  // 				PucCourse: el.PucCourse,
  // 				PucSpecialization: el.PucSpecialization,
  // 				PucYearOfComp: el.PucYearOfComp,
  // 				PucPercentage: el.PucPercentage,
  // 				PucInstitute: el.PucInstitute,
  // 				PucBoard: el.PucBoard,
  // 				PucState: '',
  // 				PucCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}
  // 	if (target === 'ug') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				UGQualification: el.UGQualification,
  // 				UGStatus: el.UGStatus,
  // 				UGCourse: el.UGCourse,
  // 				UGSpecialization: el.UGSpecialization,
  // 				UGYearOfComp: el.UGYearOfComp,
  // 				UGPercentage: el.UGPercentage,
  // 				UGInstitute: el.UGInstitute,
  // 				UGBoard: el.UGBoard,
  // 				UGState: '',
  // 				UGCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}
  // 	if (target === 'pg') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				PGQualification: el.PGQualification,
  // 				PGStatus: el.PGStatus,
  // 				PGCourse: el.PGCourse,
  // 				PGSpecialization: el.PGSpecialization,
  // 				PGYearOfComp: el.PGYearOfComp,
  // 				PGPercentage: el.PGPercentage,
  // 				PGInstitute: el.PGInstitute,
  // 				PGBoard: el.PGBoard,
  // 				PGState: '',
  // 				PGCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}
  // 	if (target === 'mphil') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				MphilQualification: el.MphilQualification,
  // 				MphilStatus: el.MphilStatus,
  // 				MphilCourse: el.MphilCourse,
  // 				MphilSpecialization: el.MphilSpecialization,
  // 				MphilYearOfComp: el.MphilYearOfComp,
  // 				MphilPercentage: el.MphilPercentage,
  // 				MphilInstitute: el.MphilInstitute,
  // 				MphilBoard: el.MphilBoard,
  // 				MphilState: '',
  // 				MphilCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}
  // 	if (target === 'phd') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				PhdQualification: el.PhdQualification,
  // 				PhdStatus: el.PhdStatus,
  // 				PhdCourse: el.PhdCourse,
  // 				PhdSpecialization: el.PhdSpecialization,
  // 				PhdYearOfComp: el.PhdYearOfComp,
  // 				PhdPercentage: el.PhdPercentage,
  // 				PhdInstitute: el.PhdInstitute,
  // 				PhdBoard: el.PhdBoard,
  // 				PhdState: '',
  // 				PhdCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}
  // 	if (target === 'others') {
  // 		data.map((el) => {
  // 			newData.push({
  // 				empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
  // 				empApplnEntriesId: el.empApplnEntriesId,
  // 				otherQualification: el.otherQualification,
  // 				otherStatus: el.otherStatus,
  // 				otherCourse: el.otherCourse,
  // 				otherSpecialization: el.otherSpecialization,
  // 				otherYearOfComp: el.otherYearOfComp,
  // 				otherPercentage: el.otherPercentage,
  // 				otherInstitute: el.otherInstitute,
  // 				otherBoard: el.otherBoard,
  // 				otherState: '',
  // 				otherCountry: '',
  // 				documentList: []
  // 			});
  // 			return '';
  // 		});
  // 	}

  // 	return newData;
  // };

  const removeOldData = (oldData) => {
    // oldData['AdditonalEducationDetails']['Tenth'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].Tenth,
    // 	'tenth'
    // );
    // oldData['AdditonalEducationDetails']['Puc'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].Puc,
    // 	'puc'
    // );
    // oldData['AdditonalEducationDetails']['UG'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].UG,
    // 	'ug'
    // );
    // oldData['AdditonalEducationDetails']['PG'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].PG,
    // 	'pg'
    // );
    // oldData['AdditonalEducationDetails']['Mphil'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].Mphil,
    // 	'mphil'
    // );
    // oldData['AdditonalEducationDetails']['Phd'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].Phd,
    // 	'phd'
    // );
    // oldData['AdditonalEducationDetails']['others'] = changeTheState(
    // 	SelectedFormState['AdditonalEducationDetails'].others,
    // 	'others'
    // );

    oldData["ConfirmAcctNo"] = "";
    oldData["PanNo"] = "";
    oldData["TwoWheelerNO"] = "";
    oldData["FourWheelerNo"] = "";
    oldData["UanNo"] = "";
    // oldData["PfNo"] = "";
    oldData["empJobDetailsDTO"] = {
      pfAccountNo: "",
      pfDate: null,
      gratuityNo: "",
      gratuityDate: null,
    };
    // oldData["gratuvityAndNomineeDetails"] = {
    //   accountDate: "",
    //   accountNo: "",
    //   uanNo: "",
    //   nomineeDetails: [],
    // };
    // oldData["pfAndNomineeDetails"] = {
    //   accountDate: "",
    //   accountNo: "",
    //   uanNo: "",
    //   nomineeDetails: [],
    // };
    oldData["haveAadhar"] = "";
    oldData["AadharNo"] = "";
    oldData["EnrolledForAadhar"] = "";
    oldData["EnrollmentId"] = "";
    oldData["EmgContactName"] = "";
    oldData["EmgContactAddress"] = "";
    oldData["EmgContactRelationship"] = "";
    oldData["EmgMobileNo"] = "";
    oldData["EmgHomeContact"] = "";
    oldData["EmgWorkContact"] = "";
    oldData["PassportNo"] = "";
    oldData["PassportIssuedDate"] = "";
    oldData["PassportStatus"] = "";
    oldData["PassportDateOfExpiry"] = "";
    oldData["PassportComments"] = "";
    oldData["visaNo"] = "";
    oldData["vissaIssuedDate"] = "";
    oldData["vissaStatus"] = "";
    oldData["visaDateOfExpiry"] = "";
    oldData["visaComments"] = "";
    oldData["fatherName"] = "";

    oldData["fatherDob"] = "";
    oldData["fatherQualification"] = "";
    oldData["fatherProfession"] = "";
    oldData["motherName"] = "";
    oldData["motherDob"] = "";
    oldData["motherQualification"] = "";
    oldData["motherProfession"] = "";
    oldData["MaritalStatus"] = "";
    oldData["SpouseName"] = "";
    oldData["spouseDob"] = "";
    oldData["spouseQualification"] = "";
    oldData["spouseProfession"] = "";
    oldData["childrenDetails"] = [
      {
        name: "",
        dob: "",
        qualification: "",
        profession: "",
      },
    ];
    oldData["Dependents"] = [
      {
        name: "",
        dob: "",
        RelationAndReason: "",
      },
    ];
    oldData["familyBackgrounnd"] = "";
    oldData["AccountWithSib"] = "";
    oldData["AcctNO"] = "";
    oldData["ConfirmAcctNo"] = "";
    oldData["IfscCode"] = "";
    setSelectedFormState(oldData);
  };

  const onChangeHandler = (event) => {
    let name = event.target.name;
    let val = event.target.value;
    var oldObj = { ...SelectedFormState };
    const pattern = "^[0-9]*$";
    let result = val.match(pattern);
    if (
      name === "EmgMobileNo" ||
      name === "EmgHomeContact" ||
      name === "EmgWorkContact" ||
      name === "AcctNO" ||
      name === "ConfirmAcctNo" ||
      name === "pfAccountNo"
    ) {
      if (result !== null) {
        setSelectedFormState({
          ...SelectedFormState,
          [name]: val,
        });
        ValidationErrorHandler(name, false);
      } else {
        ValidationErrorHandler(name, true);
      }
    } else if (name === "OfferLetterAcceptence") {
      if (val === "true") {
        oldObj[name] = val;
        oldObj["RejectionReason"] = "";
        oldObj["otherReason"] = "";
        oldObj["confirmJoiningDate"] = "";
        setSelectedFormState(oldObj);
      } else if (val === "false") {
        oldObj[name] = val;
        ReasonsApi();
        oldObj["TermsAndConditions"] = "";
        removeOldData(oldObj);
      }
    }
    else if (name === "confirmJoiningDate") {
      if (val === "true") {
        oldObj[name] = val;
        oldObj["joiningDateRejectReason"] = "";
        setSelectedFormState(oldObj);
      } else if (val === "false") {
        oldObj[name] = val;
        setSelectedFormState(oldObj);
      }
    }
    else if (name === "haveAadhar") {
      if (val === "true") {
        oldObj["EnrolledForAadhar"] = "";
        oldObj["EnrollmentId"] = "";
        oldObj[name] = val;
        setSelectedFormState(oldObj);
      } else if (val === "false") {
        oldObj["AadharNo"] = "";
        oldObj[name] = val;
        setSelectedFormState(oldObj);
      }
    } else if (name === "EnrolledForAadhar") {
      if (val === "true") {
        oldObj[name] = val;
        setSelectedFormState(oldObj);
      } else if (val === "false") {
        oldObj["EnrollmentId"] = "";
        oldObj[name] = val;
        setSelectedFormState(oldObj);
      }
    } else if (name === "AccountWithSib") {
      if (val === "true") {
        oldObj[name] = val;
        setSelectedFormState(oldObj);
      } else if (val === "false") {
        oldObj[name] = val;
        oldObj["AcctNO"] = "";
        oldObj["ConfirmAcctNo"] = "";
        oldObj["IfscCode"] = "";
        setSelectedFormState(oldObj);
      }
    } else {
      oldObj[name] = val;
      setSelectedFormState(oldObj);
    }
    if (name === "ConfirmAcctNo" && acctNumError) {
      setAcctNumError(false);
    }
    if (val !== null) {
      RemoveReqFieldErrors(name, "", "");
    }
  };

  const familyDependentChangeHandler = (event, name, index) => {
    const oldObj = { ...SelectedFormState };
    const val = event.target.value;
    oldObj.familyDetailsAddtnlList[index][name] = val;
    setSelectedFormState(oldObj);
    if (val !== null) {
      RemoveReqFieldErrors(name, "", "");
    }
  };

  const dependentDetailsHandler = (event, name, index) => {
    const oldObj = { ...SelectedFormState };
    const val = event.target.value;
    oldObj.dependentDetailsAddtnlList[index][name] = val;
    setSelectedFormState(oldObj);
    if (val !== null) {
      RemoveReqFieldErrors(name, "", "");
    }
  };

  const selectHandler = (selected, target) => {
    const oldObj = { ...SelectedFormState };
    if (target === "RejectionReason") {
      oldObj["RejectionReason"] = selected;
      oldObj["otherReason"] = "";
    }
    if (target === "MaritalStatus") {
      const spouseObj = {
        empFamilyDetailsAddtnlId: "",
        empApplnPersonalDataId: selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId,
        empPersonalDataId: "",
        relationship: "SPOUSE",
        dependentName: "",
        dependentDob: "",
        dependentQualification: "",
        dependentProfession: "",
        dependDOB: null,
      };
      oldObj["MaritalStatus"] = selected;
      const tempArray = oldObj["familyDetailsAddtnlList"];
      if (selected?.label === "Married") {
        if (tempArray?.length === 2) {
          tempArray.push(spouseObj)
        }
      } else {
        if (tempArray?.length === 3) {
          const remInd = tempArray.findIndex((item) => item?.relationship === "SPOUSE")
          tempArray.splice(remInd, 1)
        }
      }
    }
    setSelectedFormState(oldObj);
    if (selected !== null) {
      RemoveReqFieldErrors(target, "", "");
    }
  };

  const dateHandlerString = (date, name) => {
    const newState = { ...SelectedFormState };
    newState[name] = date;
    setSelectedFormState(newState);
  };

  const DateChangeHandler = (date, target, id, stateName) => {
    let name = target;
    let selected = date;
    var oldObj = { ...SelectedFormState };
    if (stateName === "NormalDate") {
      oldObj[name] = selected;
    }
    if (stateName === null) {
      oldObj[name] = Utils.convertDateTimeObjToLocaleDate(selected);
    }
    if (stateName === "empGratuityNomineesDTO") {
      if (id !== null) {
        oldObj[stateName][id][name] = Utils.convertDateObjToLocaleDate(selected);
      } else {
        oldObj[stateName][name] = Utils.convertDateObjToLocaleDate(selected);
      }
    }
    if (stateName === "empPfNomineesDTO") {
      if (id !== null) {
        oldObj[stateName][id][name] = Utils.convertDateObjToLocaleDate(selected);
      } else {
        oldObj[stateName][name] = Utils.convertDateObjToLocaleDate(selected);
      }
    }
    if (stateName === "empJobDetailsDTO") {
      if (id !== null) {
        oldObj[stateName][id][name] = Utils.convertDateObjToLocaleDate(selected);
      } else {
        oldObj[stateName][name] = Utils.convertDateObjToLocaleDate(selected);
      }
      //   oldObj[stateName][id][name] = selected;
      // oldObj.empJobDetailsDTO[name] = Utils.convertDateObjToLocaleDate(selected);
    }
    if (stateName === "familyDetailsAddtnlList") {
      oldObj[stateName][id][name] = Utils.convertDateObjToLocaleDate(selected);
    }
    if (stateName === "dependentDetailsAddtnlList") {
      oldObj[stateName][id][name] = Utils.convertDateObjToLocaleDate(selected);
    }
    if (stateName === "preferedJoiningDateTime") {
      oldObj[stateName][id][name] = Utils.convertDateTimeObjToLocaleDate(selected);
    }
    setSelectedFormState(oldObj);
  };

  //   const DateChangeHandler = (date, target, id, stateName) => {
  //     let name = target;
  //
  //     var oldObj = { ...SelectedFormState };
  //     if (stateName === "NormalDate") {
  //       oldObj[name] = selected;
  //     }
  //     if (stateName === "pfAndNomineeDetails" || stateName === "gratuvityAndNomineeDetails") {
  //       if (id !== null) {
  //         oldObj[stateName].nomineeDetails[id][name] = selected;
  //       } else {
  //         oldObj[stateName][name] = selected;
  //       }
  //     }
  //     if (stateName === "childrenDate") {
  //       oldObj["childrenDetails"][id][name] = selected;
  //     }
  //     if (stateName === "DependentDate") {
  //       oldObj["Dependents"][id][name] = selected;
  //     }
  //     setSelectedFormState(oldObj);
  //   };

  const EducationSelectHandler = (option, stateName, id, name) => {
    const selected = option;
    const oldData = { ...SelectedFormState };
    oldData["AdditonalEducationDetails"][stateName][id][name] = selected;
    setSelectedFormState(oldData);
    if (selected !== null) {
      RemoveReqFieldErrors(name, stateName, id);
    }
  };
  //   const NomineeDetailsHandler = (event, stateName, index) => {
  //     const oldData = { ...SelectedFormState };
  //     const val = event.target.value;
  //     const name = event.target.name;
  //     if (stateName === "pfAndNomineeDetails" || stateName === "gratuvityAndNomineeDetails") {
  //       if (index !== null) {
  //         oldData[stateName].nomineeDetails[index][name] = val;
  //       } else {
  //         oldData[stateName][name] = val;
  //       }
  //     }
  //     if (stateName === "childrenDetails") {
  //       oldData["childrenDetails"][index][name] = val;
  //     }
  //     if (stateName === "Dependents") {
  //       oldData["Dependents"][index][name] = val;
  //     }
  //     setSelectedFormState(oldData);
  //   };

  const NomineeDetailsHandler = (event, stateName, index) => {
    const oldData = { ...SelectedFormState };
    const val = event.target.value;
    const name = event.target.name;
    if (stateName === "empJobDetailsDTO") {
      oldData[stateName][name] = val;
    }
    if (stateName === "empGratuityNomineesDTO") {
      if (name === "sharePercentage" && val !== "") {
        let totalShareAssigned = 0;
        for (let i = 0; i < oldData[stateName]?.length; i++) {
          if (index !== i) {
            totalShareAssigned += parseInt(oldData[stateName][i]?.sharePercentage, 10) || 0;
          }
        }
        if (totalShareAssigned + parseInt(val, 10) <= 100) {
          oldData[stateName][index][name] = parseInt(val, 10);
        } else {
          toast.warn("Share could not be greater than 100%");
        }
      } else {
        oldData[stateName][index][name] = val;
      }
    } else {
      oldData[stateName][name] = val;
    }
    if (stateName === "empPfNomineesDTO") {
      if (name === "sharePercentage" && val !== "") {
        let totalShareAssigned = 0;
        for (let i = 0; i < oldData[stateName]?.length; i++) {
          if (index !== i) {
            totalShareAssigned += parseInt(oldData[stateName][i]?.sharePercentage, 10) || 0;
          }
        }
        if (totalShareAssigned + parseInt(val, 10) <= 100) {
          oldData[stateName][index][name] = parseInt(val, 10);
        } else {
          toast.warn("Share could not be greater than 100%");
        }
      } else {
        oldData[stateName][index][name] = val;
      }
    } else {
      oldData[stateName][name] = val;
    }
    setSelectedFormState(oldData);
  };

  // Checkbox handler:
  const CheckBoxHandler = (event) => {
    let name = event.target.name;
    let val = event.target.checked;
    setSelectedFormState({
      ...SelectedFormState,
      [name]: val,
    });
    $('#termsAndConditionText').removeClass('text-danger')
  };

  const AddMoreHandler = (event) => {
    const oldData = { ...SelectedFormState };
    if (event.target.name === "AddGratuNominee") {
      const OldArray = oldData?.empGratuityNomineesDTO || [];
      const lastItem = OldArray[OldArray.length - 1];
      if (
        !ERPUtils.isNullOrEmpty(OldArray) &&
        (ERPUtils.isNullorWhiteSpace(lastItem.nominee) ||
          ERPUtils.isNullorWhiteSpace(lastItem.nomineeAddress) ||
          ERPUtils.isNullorWhiteSpace(lastItem.nomineesDob) ||
          ERPUtils.isNullorWhiteSpace(lastItem.nomineeRelationship) ||
          ERPUtils.isNullorWhiteSpace(lastItem.sharePercentage))
      ) {
        setErrorMsg("Please fill the existing Gratuity details to add more !");
        AlertError();
      } else {
        setErrorMsg("");
        const totalSharePercentage = OldArray.reduce((total, item) => total + parseInt(item.sharePercentage, 10), 0);

        if (totalSharePercentage >= 100) {
          toast.warn("Total share percentage cannot exceed 100%!");
        } else {
          setErrorMsg("");
          OldArray.push({
            empJobDetailsId: selectedRoundData.empJobDetailsDTO.empJobDetailsId,
            empPfGratuityNomineesId: "",
            isGratuity: null,
            isPf: null,
            nominee: "",
            nomineeAddress: "",
            nomineesDob: "",
            nomineeRelationship: "",
            sharePercentage: "",
            under18GuardName: "",
            under18GuardianAddress: "",
          });
          oldData.empGratuityNomineesDTO = OldArray;
          setSelectedFormState(oldData);
        }
      }
    }
    if (event.target.name === "AddPfNominee") {
      const OldArray = oldData?.empPfNomineesDTO || [];
      const lastItem = OldArray[OldArray.length - 1];
      if (
        !ERPUtils.isNullOrEmpty(OldArray) &&
        (ERPUtils.isNullorWhiteSpace(lastItem.nominee) ||
          ERPUtils.isNullorWhiteSpace(lastItem.nomineeAddress) ||
          ERPUtils.isNullorWhiteSpace(lastItem.nomineesDob) ||
          ERPUtils.isNullorWhiteSpace(lastItem.nomineeRelationship) ||
          ERPUtils.isNullorWhiteSpace(lastItem.sharePercentage))
      ) {
        setErrorMsg("Please fill the existing Pf Nominee details to add more !");
        AlertError();
      } else {
        setErrorMsg("");
        const totalSharePercentage = OldArray.reduce((total, item) => total + parseInt(item.sharePercentage, 10), 0);

        if (totalSharePercentage >= 100) {
          toast.warn("Total share percentage cannot exceed 100%!");
        } else {
          OldArray.push({
            empJobDetailsId: selectedRoundData.empJobDetailsDTO.empJobDetailsId,
            empPfGratuityNomineesId: "",
            isGratuity: null,
            isPf: null,
            nominee: "",
            nomineeAddress: "",
            nomineesDob: "",
            nomineeRelationship: "",
            sharePercentage: "",
            under18GuardName: "",
            under18GuardianAddress: "",
          });
          oldData.empPfNomineesDTO = OldArray;
          setSelectedFormState(oldData);
        }
      }
    }
    // if (event.target.name === "AddmoreChild") {
    //   const OldArray = oldData.childrenDetails;
    //   const lastItem = OldArray[OldArray.length - 1];
    //   if (!ERPUtils.isNullOrEmpty(OldArray) && (ERPUtils.isNullorWhiteSpace(lastItem.name) || ERPUtils.isNullorWhiteSpace(lastItem.dob))) {
    //     setErrorMsg("Please fill the existing Child details to add more !");
    //     AlertError();
    //   } else {
    //     OldArray.push({
    //       name: "",
    //       dob: "",
    //       qualification: "",
    //       profession: "",
    //     });
    //     setSelectedFormState(oldData);
    //   }
    // }
    if (event.target.name === "AddmoreDependents") {
      const OldArray = oldData.dependentDetailsAddtnlList;
      const lastItem = OldArray[OldArray.length - 1];
      if (
        !ERPUtils.isNullOrEmpty(OldArray) &&
        (ERPUtils.isNullorWhiteSpace(lastItem.dependentName) ||
          ERPUtils.isNullorWhiteSpace(lastItem.relationship) ||
          ERPUtils.isNullorWhiteSpace(lastItem.dependDOB))
      ) {
        setErrorMsg("Please fill the existing Dependent details to add more !");
        AlertError();
      } else {
        OldArray.push({
          empFamilyDetailsAddtnlId: "",
          empApplnPersonalDataId: selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId,
          empPersonalDataId: "",
          relationship: "",
          dependentName: "",
          dependentDob: "",
          dependentQualification: "",
          dependentProfession: "",
          dependDOB: null,
        });
        setSelectedFormState(oldData);
      }
    }
  };

  const RemoveHandler = (event) => {
    const id = event.target.id;
    const oldData = { ...SelectedFormState };
    if (event.target.name === "RemovePfNominee") {
      const OldArray = oldData?.empPfNomineesDTO || [];
      OldArray.splice(id, 1);
      oldData.empPfNomineesDTO = OldArray;
      setSelectedFormState(oldData);
    }
    if (event.target.name === "RemoveGrtuNominee") {
      const OldArray = oldData.empGratuityNomineesDTO || [];
      OldArray.splice(id, 1);
      oldData.empGratuityNomineesDTO = OldArray;
      setSelectedFormState(oldData);
    }
    // if (event.target.name === "RemoveChild") {
    //   const OldArray = oldData.childrenDetails;
    //   OldArray.splice(id, 1);
    //   setSelectedFormState(oldData);
    // }
    if (event.target.name === "RemoveDependent") {
      const OldArray = oldData.dependentDetailsAddtnlList;
      OldArray.splice(id, 1);
      setSelectedFormState(oldData);
    }
  };

  //File upload:
  const onFileChange = (event, index, parent) => {
    let id = index;
    if (!ERPUtils.isUndefinedOrNull(event.target.files.length > 0)) {
      Object.keys(event.target.files).map((el) => {
        const name = event.target.files[el].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const extension = name.substring(lastDot + 1);
        setFileForUpload(event.target.files[el], fileName, extension, parent, id);
        return "";
      });
    }
    event.target.value = null;
    return "";
  };

  const setFileForUpload = (file, fileName, extension, parent, id) => {
    let name = "AdditonalEducationDetails";
    let newState = SelectedFormState[name];
    let UploadedImages = newState[parent][id].documentList;
    const url = URL.createObjectURL(file);
    UploadedImages.push({
      file,
      url,
      fileName,
      extension,
      recordStatus: "A",
      newFile: true,
    });
    setSelectedFormState({
      ...SelectedFormState,
      [name]: newState,
    });
  };

  const imageRemoveHandler = (event, name, idx) => {
    var index = event.target.id;
    var fileArray = { ...SelectedFormState };
    var newArray = fileArray["AdditonalEducationDetails"][name][idx].documentList;
    if (index !== -1) {
      if (ERPUtils.isUndefinedOrNull(newArray[index].id) === true) {
        newArray.splice(index, 1);
      } else {
        newArray[index].recordStatus = "D";
      }
      setSelectedFormState(fileArray);
    }
  };

  const openImageInTab = (event) => {
    window.open(event.target.src);
  };

  // To map the Api data for education details (on Component Load):
  const mapEducationData = (responseData, dropDownData, stateName) => {
    let mappedData;
    if (stateName === "Others") {
      let OthersData = [];
      responseData.map((el, index) => {
        OthersData.push({
          empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
          empApplnEntriesId: el.empApplnEntriesId,
          qualificationOthers: el.qualificationOthers,
          // currentStatus: MatchDropDataFunction('SingleSelect', el.currentStatus),
          currentStatus: el.currentStatus,
          course: el.course,
          specialization: el.specialization,
          yearOfCompletion: el.yearOfCompletion,
          gradeOrPercentage: el.gradeOrPercentage,
          institute: el.institute,
          boardOrUniversity: el.boardOrUniversity,
          qualificationLevelCode: el.qualificationLevelCode,
          // stateId: MatchDropDataFunction('StateAndCitySelect', el.stateId, dropDownData[0][0]),
          // countryId: MatchDropDataFunction('StateAndCitySelect', el.countryId, dropDownData[0][1]),
          stateId: el.stateId,
          countryId: el.countryId,
          stateOther: el?.stateOther,
          // documentList: FrameImageObject(el.documentList,'Education')
          documentList: ERPUtils.isUndefinedOrNull(el.documentList) === false ? el.documentList : [],
        });
        return "";
      });
      mappedData = OthersData;
    }

    if (stateName === "common") {
      let qualificationArray = [];
      dropDownData[0][2].map((el) => {
        if (parseInt(el.qualificationLevelDegreeOrder, 10) <= parseInt(responseData, 10)) {
          dropDownData[1].map((item, index) => {
            if (parseInt(item.qualificationLevelId, 10) === parseInt(el.value, 10)) {
              qualificationArray.push({
                empApplnEducationalDetailsId: item.empApplnEducationalDetailsId,
                empApplnEntriesId: item.empApplnEntriesId,
                qualificationName: item.qualificationName,
                qualificationLevelId: item.qualificationLevelId,
                // currentStatus: MatchDropDataFunction('SingleSelect', item.currentStatus),
                currentStatus: item.currentStatus,
                course: item.course,
                specialization: item.specialization,
                yearOfCompletion: item.yearOfCompletion,
                gradeOrPercentage: item.gradeOrPercentage,
                institute: item.institute,
                boardOrUniversity: item.boardOrUniversity,
                qualificationLevelDegreeOrder: el.qualificationLevelDegreeOrder,
                qualificationLevelCode: el.qualificationLevelCode,
                // stateId: MatchDropDataFunction(
                // 	'StateAndCitySelect',
                // 	item.stateId,
                // 	dropDownData[0][0]
                // ),
                // countryId: MatchDropDataFunction(
                // 	'StateAndCitySelect',
                // 	item.countryId,
                // 	dropDownData[0][1]
                // ),
                stateId: item.stateId,
                countryId: item.countryId,
                // documentList: FrameImageObject(item.documentList,"Education")
                documentList: ERPUtils.isUndefinedOrNull(item.documentList) === false ? item.documentList : [],
              });
            }
            return "";
          });
        }
        return "";
      });
      mappedData = qualificationArray.length > 0 ? qualificationArray : [];
    }
    // if (stateName === 'puc') {
    // 	let pucData = [];
    // 	dropDownData[0][2].map((el) => {
    // 		if (el.qualificationLevelDegreeOrder <= responseData && el.value === ('2' || 2)) {
    // 			dropDownData[1].map((item, index) => {
    // 				if (item.qualificationLevelId === el.value) {
    // 					pucData.push({
    // 						empApplnEducationalDetailsId: item.empApplnEducationalDetailsId,
    // 						empApplnEntriesId: item.empApplnEntriesId,
    // 						PucQualification: item.qualificationName,
    // 						PucStatus: MatchDropDataFunction('SingleSelect', item.currentStatus),
    // 						PucCourse: item.course,
    // 						PucSpecialization: item.specialization,
    // 						PucYearOfComp: item.yearOfCompletion,
    // 						PucPercentage: item.gradeOrPercentage,
    // 						PucInstitute: item.institute,
    // 						PucBoard: item.boardOrUniversity,
    // 						PucState: MatchDropDataFunction('StateAndCitySelect', item.stateId, dropDownData[0][0]),
    // 						PucCountry: MatchDropDataFunction(
    // 							'StateAndCitySelect',
    // 							item.countryId,
    // 							dropDownData[0][1]
    // 						),
    // 						// documentList: FrameImageObject(item.documentList,"Education")
    // 						documentList: []
    // 					});
    // 					addReqErrors.puc.push(index);
    // 				}
    // 				return '';
    // 			});
    // 		}
    // 		return '';
    // 	});
    // 	mappedData = pucData.length > 0 ? pucData : SelectedFormState.AdditonalEducationDetails.Puc;
    // }

    return mappedData;
  };

  // To give the dropdown format for api data (on Component Load):
  // const MatchDropDataFunction = (type, value, data) => {
  // 	let match;
  // 	if (type === 'SingleSelect') {
  // 		let stateData = '';
  // 		EducationStatus.map((el) => {
  // 			if (el.value === value) {
  // 				stateData = el.label;
  // 			}
  // 			return '';
  // 		});
  // 		match = stateData;
  // 	}
  // 	if (type === 'StateAndCitySelect') {
  // 		let stateData = '';
  // 		data.map((el) => {
  // 			if (parseInt(el.value) === parseInt(value)) {
  // 				stateData = el;
  // 			}
  // 			return '';
  // 		});
  // 		match = stateData;
  // 	}
  // 	return match === (null || undefined) ? '' : match;
  // };

  // To Map the Api Data for Family details (on Component Load):
  const mapFamilyDetails = (prevData, state) => {
    let modifiedObj = prevData;

    if (state[0]?.relationship === "FATHER") {
      modifiedObj["empFamilyDetailsAddtnlId"] = ERPUtils.isUndefinedOrNull(state[0].empFamilyDetailsAddtnlId) === false ? state[0].empFamilyDetailsAddtnlId : "";
      modifiedObj["empApplnPersonalDataId"] = ERPUtils.isUndefinedOrNull(state[0].empFamilyDetailsAddtnlId) === false ? state[0].empFamilyDetailsAddtnlId : "";
      modifiedObj["dependentName"] = ERPUtils.isUndefinedOrNull(state[0].dependentName) === false ? state[0].dependentName : "";
      modifiedObj["dependentDob"] = ERPUtils.isUndefinedOrNull(state[0].dependentDob) === false ? state[0].dependentDob : "";
      modifiedObj["dependentQualification"] = ERPUtils.isUndefinedOrNull(state[0].dependentQualification) === false ? state[0].dependentQualification : "";
      modifiedObj["dependentProfession"] = ERPUtils.isUndefinedOrNull(state[0].dependentProfession) === false ? state[0].dependentProfession : "";
    }
    if (state[1]?.relationship === "MOTHER") {
      modifiedObj["empFamilyDetailsAddtnlId"] = ERPUtils.isUndefinedOrNull(state[1].empFamilyDetailsAddtnlId) === false ? state[1].empFamilyDetailsAddtnlId : "";
      modifiedObj["empApplnPersonalDataId"] = ERPUtils.isUndefinedOrNull(state[1].empFamilyDetailsAddtnlId) === false ? state[1].empFamilyDetailsAddtnlId : "";
      modifiedObj["dependentName"] = ERPUtils.isUndefinedOrNull(state[1].dependentName) === false ? state[1].dependentName : "";
      modifiedObj["dependentDob"] = ERPUtils.isUndefinedOrNull(state[1].dependentDob) === false ? state[1].dependentDob : "";
      modifiedObj["dependentQualification"] = ERPUtils.isUndefinedOrNull(state[1].dependentQualification) === false ? state[1].dependentQualification : "";
      modifiedObj["dependentProfession"] = ERPUtils.isUndefinedOrNull(state[1].dependentProfession) === false ? state[1].dependentProfession : "";
    }
    // if (!SelectedFormState.MaritalStatus === "Married") {
    if (state[2]?.relationship === "SPOUSE") {
      modifiedObj["empFamilyDetailsAddtnlId"] = ERPUtils.isUndefinedOrNull(state[2].empFamilyDetailsAddtnlId) === false ? state[2].empFamilyDetailsAddtnlId : "";
      modifiedObj["empApplnPersonalDataId"] = ERPUtils.isUndefinedOrNull(state[2].empFamilyDetailsAddtnlId) === false ? state[2].empFamilyDetailsAddtnlId : "";
      modifiedObj["dependentName"] = ERPUtils.isUndefinedOrNull(state[2].dependentName) === false ? state[2].dependentName : "";
      modifiedObj["dependentDob"] = ERPUtils.isUndefinedOrNull(state[2].dependentDob) === false ? state[2].dependentDob : "";
      modifiedObj["dependentQualification"] = ERPUtils.isUndefinedOrNull(state[2].dependentQualification) === false ? state[2].dependentQualification : "";
      modifiedObj["dependentProfession"] = ERPUtils.isUndefinedOrNull(state[2].dependentProfession) === false ? state[2].dependentProfession : "";
    }
    // }

    // let newArray = [];
    // state.map((item) => {
    //   newArray.push({
    //     // empFamilyDetailsAddtnlId: ERPUtils.isUndefinedOrNull(item.empFamilyDetailsAddtnlId) === false ? item.empFamilyDetailsAddtnlId : "",
    //     // empApplnPersonalDataId: ERPUtils.isUndefinedOrNull(item.empApplnPersonalDataId) === false ? item.empApplnPersonalDataId : "",
    //     dependentName: item.dependentName,
    //     dependDOB: ERPUtils.isUndefinedOrNull(item.dependDOB) === false ? ERPUtils.validateDate(item.dependDOB) : "",
    //     otherDependentRelationship: ERPUtils.isUndefinedOrNull(item.otherDependentRelationship) === false ? item.otherDependentRelationship : "",
    //   });
    //   return "";
    // });
    return modifiedObj;
  };

  const mapDependantDetails = (prevData, state) => {
    let modiObj = prevData;
    const newArray = [];
    state.map((el) => {
      newArray.push({
        empApplnPersonalDataId: ERPUtils.isUndefinedOrNull(el.empApplnPersonalDataId) === false ? el.empApplnPersonalDataId : "",
        dependentName: ERPUtils.isUndefinedOrNull(el.dependentName) === false ? el.dependentName : "",
        dependDOB: ERPUtils.isUndefinedOrNull(el.dependDOB) === false ? el.dependDOB : "",
        relationship: ERPUtils.isUndefinedOrNull(el.relationship) === false ? el.relationship : "",
      });
      modiObj["dependentDetailsAddtnlList"] = newArray.length > 0 ? newArray : selectedRoundData.dependentDetailsAddtnlList;
      // modiObj["empApplnPersonalDataId"] = ERPUtils.isUndefinedOrNull(el.empApplnPersonalDataId) === false ? el.empApplnPersonalDataId : "";
      // modiObj["dependentName"] = ERPUtils.isUndefinedOrNull(el.dependentName) === false ? el.dependentName : "";
      // modiObj["dependDOB"] = ERPUtils.isUndefinedOrNull(el.dependDOB) === false ? el.dependDOB : "";
      // modiObj["otherDependentRelationship"] = ERPUtils.isUndefinedOrNull(el.otherDependentRelationship) === false ? el.otherDependentRelationship : "";
      return null;
    });
    return modiObj;
  };

  const mapGratuityDetails = (prevData, state) => {
    let modiObj = prevData;
    const newArray = [];
    state.map((el) => {
      newArray.push({
        empId: ERPUtils.isUndefinedOrNull(el.empId) === false ? el.empId : "",
        empJobDetailsId: ERPUtils.isUndefinedOrNull(el.empJobDetailsId) === false ? el.empJobDetailsId : "",
        empPfGratuityNomineesId: ERPUtils.isUndefinedOrNull(el.empPfGratuityNomineesId) === false ? el.empPfGratuityNomineesId : "",
        isGratuity: ERPUtils.isUndefinedOrNull(el.isGratuity) === false ? el.isGratuity : "",
        isPf: ERPUtils.isUndefinedOrNull(el.isGratuity) === false ? el.isGratuity : "",
        nominee: ERPUtils.isUndefinedOrNull(el.nominee) === false ? el.nominee : "",
        nomineeAddress: ERPUtils.isUndefinedOrNull(el.nomineeAddress) === false ? el.nomineeAddress : "",
        nomineesDob: ERPUtils.isUndefinedOrNull(el.nomineesDob) === false ? el.nomineesDob : "",
        nomineeRelationship: ERPUtils.isUndefinedOrNull(el.nomineeRelationship) === false ? el.nomineeRelationship : "",
        sharePercentage: ERPUtils.isUndefinedOrNull(el.sharePercentage) === false ? el.sharePercentage : "",
        under18GuardName: ERPUtils.isUndefinedOrNull(el.under18GuardName) === false ? el.under18GuardName : "",
        under18GuardianAddress: ERPUtils.isUndefinedOrNull(el.under18GuardianAddress) === false ? el.under18GuardianAddress : "",
      });
      modiObj["empGratuityNomineesDTO"] = newArray.length > 0 ? newArray : selectedRoundData.empGratuityNomineesDTO;
      return null;
    });
    return modiObj;
  };

  const mapPfDetails = (prevData, state) => {
    let modiObj = prevData;
    const newArray = [];
    state.map((el) => {
      newArray.push({
        empId: ERPUtils.isUndefinedOrNull(el.empId) === false ? el.empId : "",
        empJobDetailsId: ERPUtils.isUndefinedOrNull(el.empJobDetailsId) === false ? el.empJobDetailsId : "",
        empPfGratuityNomineesId: ERPUtils.isUndefinedOrNull(el.empPfGratuityNomineesId) === false ? el.empPfGratuityNomineesId : "",
        isGratuity: ERPUtils.isUndefinedOrNull(el.isGratuity) === false ? el.isGratuity : "",
        isPf: ERPUtils.isUndefinedOrNull(el.isGratuity) === false ? el.isGratuity : "",
        nominee: ERPUtils.isUndefinedOrNull(el.nominee) === false ? el.nominee : "",
        nomineeAddress: ERPUtils.isUndefinedOrNull(el.nomineeAddress) === false ? el.nomineeAddress : "",
        nomineesDob: ERPUtils.isUndefinedOrNull(el.nomineesDob) === false ? el.nomineesDob : "",
        nomineeRelationship: ERPUtils.isUndefinedOrNull(el.nomineeRelationship) === false ? el.nomineeRelationship : "",
        sharePercentage: ERPUtils.isUndefinedOrNull(el.sharePercentage) === false ? el.sharePercentage : "",
        under18GuardName: ERPUtils.isUndefinedOrNull(el.under18GuardName) === false ? el.under18GuardName : "",
        under18GuardianAddress: ERPUtils.isUndefinedOrNull(el.under18GuardianAddress) === false ? el.under18GuardianAddress : "",
      });
      modiObj["empPfNomineesDTO"] = newArray.length > 0 ? newArray : selectedRoundData.empPfNomineesDTO;
      return null;
    });
    return modiObj;
  };
  // To assign data from Api to the component State  (on Component Load):
  const FrameEducationData = (dropdownDatas) => {
    var oldObj = { ...SelectedFormState };
    if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO) === false) {
      oldObj["PanNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.panNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.panNo
          : SelectedFormState.PanNo;
      oldObj["FourWheelerNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.fourWheelerNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.fourWheelerNo
          : SelectedFormState.FourWheelerNo;
      oldObj["TwoWheelerNO"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.twoWheelerNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.twoWheelerNo
          : SelectedFormState.TwoWheelerNO;

      oldObj["EmgContactName"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.emergencyContactName) === false
          ? selectedRoundData.additionalPersonalDataDTO.emergencyContactName
          : SelectedFormState.EmgContactName;

      oldObj["EmgContactAddress"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.emergencyContactAddress) === false
          ? selectedRoundData.additionalPersonalDataDTO.emergencyContactAddress
          : SelectedFormState.EmgContactAddress;

      oldObj["EmgContactRelationship"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.emergencyContactRelatonship) === false
          ? selectedRoundData.additionalPersonalDataDTO.emergencyContactRelatonship
          : SelectedFormState.EmgContactRelationship;

      oldObj["EmgMobileNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.emergencyMobileNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.emergencyMobileNo
          : SelectedFormState.EmgMobileNo;

      oldObj["EmgHomeContact"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.emergencyContactHome) === false
          ? selectedRoundData.additionalPersonalDataDTO.emergencyContactHome
          : SelectedFormState.EmgHomeContact;
      oldObj["EmgWorkContact"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.emergencyContactWork) === false
          ? selectedRoundData.additionalPersonalDataDTO.emergencyContactWork
          : SelectedFormState.EmgWorkContact;

      oldObj["PassportNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.passportNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.passportNo
          : SelectedFormState.PassportNo;

      oldObj["PassportIssuedDate"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.passportIssuedDate) === false
          ? ERPUtils.validateDate(selectedRoundData.additionalPersonalDataDTO.passportIssuedDate)
          : ERPUtils.validateDate(SelectedFormState.PassportIssuedDate);

      oldObj["PassportStatus"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.passportStatus) === false
          ? selectedRoundData.additionalPersonalDataDTO.passportStatus
          : SelectedFormState.PassportStatus;

      oldObj["PassportDateOfExpiry"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.passportDateOfExpiry) === false
          ? ERPUtils.validateDate(selectedRoundData.additionalPersonalDataDTO.passportDateOfExpiry)
          : ERPUtils.validateDate(SelectedFormState.PassportDateOfExpiry);

      oldObj["PassportComments"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.passportComments) === false
          ? selectedRoundData.additionalPersonalDataDTO.passportComments
          : SelectedFormState.PassportComments;

      oldObj["visaNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.visaNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.visaNo
          : SelectedFormState.visaNo;

      oldObj["vissaIssuedDate"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.visaIssuedDate) === false
          ? ERPUtils.validateDate(selectedRoundData.additionalPersonalDataDTO.visaIssuedDate)
          : ERPUtils.validateDate(SelectedFormState.vissaIssuedDate);
      oldObj["vissaStatus"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.visaStatus) === false
          ? selectedRoundData.additionalPersonalDataDTO.visaStatus
          : SelectedFormState.vissaStatus;
      oldObj["visaDateOfExpiry"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.visaDateOfExpiry) === false
          ? ERPUtils.validateDate(selectedRoundData.additionalPersonalDataDTO.visaDateOfExpiry)
          : ERPUtils.validateDate(SelectedFormState.visaDateOfExpiry);
      oldObj["visaComments"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.visaComments) === false
          ? selectedRoundData.additionalPersonalDataDTO.visaComments
          : SelectedFormState.visaComments;

      oldObj["familyBackgrounnd"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.familyBackgroundBrief) === false
          ? selectedRoundData.additionalPersonalDataDTO.familyBackgroundBrief
          : SelectedFormState.familyBackgrounnd;

      oldObj["haveAadhar"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.isAadharAvailable) === false
          ? selectedRoundData.additionalPersonalDataDTO.isAadharAvailable
          : SelectedFormState.haveAadhar;
      oldObj["AadharNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.aadharNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.aadharNo
          : SelectedFormState.AadharNo;
      oldObj["EnrolledForAadhar"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.isAadharEnrolled) === false
          ? selectedRoundData.additionalPersonalDataDTO.isAadharEnrolled
          : SelectedFormState.EnrolledForAadhar;
      oldObj["EnrollmentId"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.additionalPersonalDataDTO.aadharEnrolledNo) === false
          ? selectedRoundData.additionalPersonalDataDTO.aadharEnrolledNo
          : SelectedFormState.EnrollmentId;
    }
    // Educational Details:
    if (
      ERPUtils.isUndefinedOrNull(selectedRoundData) === false &&
      ERPUtils.isUndefinedOrNull(selectedRoundData.educationalDetailDTO) === false &&
      ERPUtils.isUndefinedOrNull(selectedRoundData.educationalDetailDTO.highestQualificationLevelId) === false
    ) {
      oldObj["AdditonalEducationDetails"].qualificationList = [];
      if (
        ERPUtils.isUndefinedOrNull(selectedRoundData.educationalDetailDTO.qualificationLevelsList) === false &&
        selectedRoundData.educationalDetailDTO.qualificationLevelsList.length > 0
      ) {
        // let dataArray = selectedRoundData.educationalDetailDTO.qualificationLevelsList;
        // for (let index = 0; index < dataArray.length; index++) {
        let array = mapEducationData(
          selectedRoundData.educationalDetailDTO.highestQualificationLevelId,
          [dropdownDatas, selectedRoundData.educationalDetailDTO.qualificationLevelsList],
          "common"
        );
        if (!ERPUtils.isNullorWhiteSpace(array) && !ERPUtils.isNullOrEmpty(array) && array.length > 0) {
          oldObj["AdditonalEducationDetails"].qualificationList.push(...array);
        }
        // }
      }
      oldObj["AdditonalEducationDetails"].others = [];
      if (
        ERPUtils.isUndefinedOrNull(selectedRoundData.educationalDetailDTO.otherQualificationLevelsList) === false &&
        selectedRoundData.educationalDetailDTO.otherQualificationLevelsList.length > 0
      ) {
        // let dataArray = selectedRoundData.educationalDetailDTO.qualificationLevelsList;
        // for (let index = 0; index < dataArray.length; index++) {
        let array = mapEducationData(selectedRoundData.educationalDetailDTO.otherQualificationLevelsList, [dropdownDatas, ""], "Others");
        if (!ERPUtils.isNullorWhiteSpace(array) && !ERPUtils.isNullOrEmpty(array) && array.length > 0) {
          oldObj["AdditonalEducationDetails"].others.push(...array);
        }
        // }
      }
    }

    // jobDetails:
    if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO) === false) {
      oldObj["UanNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.uanNo) === false ? selectedRoundData.empJobDetailsDTO.uanNo : SelectedFormState.UanNo;
      oldObj["empJobDetailsDTO"].pfAccountNo =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.pfAccountNo) === false
          ? selectedRoundData.empJobDetailsDTO.pfAccountNo
          : SelectedFormState.empJobDetailsDTO.pfAccountNo;
      oldObj["empJobDetailsDTO"].pfDate =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.pfDate) === false
          ? selectedRoundData.empJobDetailsDTO.pfDate
          : SelectedFormState.empJobDetailsDTO.pfDate;
      oldObj["empJobDetailsDTO"].gratuityNo =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.gratuityNo) === false
          ? selectedRoundData.empJobDetailsDTO.gratuityNo
          : SelectedFormState.empJobDetailsDTO.gratuityNo;
      oldObj["empJobDetailsDTO"].gratuityDate =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.gratuityDate) === false
          ? selectedRoundData.empJobDetailsDTO.gratuityDate
          : SelectedFormState.empJobDetailsDTO.gratuityDate;
      oldObj["AccountWithSib"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.isSibAccountAvailable) === false
          ? selectedRoundData.empJobDetailsDTO.isSibAccountAvailable
          : SelectedFormState.AccountWithSib;
      oldObj["AcctNO"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.sibAccountBank) === false
          ? selectedRoundData.empJobDetailsDTO.sibAccountBank
          : SelectedFormState.AcctNO;
      oldObj["ConfirmAcctNo"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.sibAccountBank) === false
          ? selectedRoundData.empJobDetailsDTO.sibAccountBank
          : SelectedFormState.AcctNO;
      oldObj["IfscCode"] =
        ERPUtils.isUndefinedOrNull(selectedRoundData.empJobDetailsDTO.ifscCode) === false
          ? selectedRoundData.empJobDetailsDTO.ifscCode
          : SelectedFormState.IfscCode;
    }
    // Nominee Details:
    // if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.empGratuityNomineesDTO) === false) {
    //   oldObj["empGratuityNomineesDTO"] =
    //     ERPUtils.isUndefinedOrNull(selectedRoundData.empGratuityNomineesDTO) === false
    //       ? selectedRoundData.empGratuityNomineesDTO
    //       : SelectedFormState.empGratuityNomineesDTO;
    // }
    if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.empGratuityNomineesDTO) === false) {
      if (selectedRoundData.empGratuityNomineesDTO.length > 0) {
        oldObj = mapGratuityDetails(oldObj, selectedRoundData.empGratuityNomineesDTO);
        oldObj["empGratuityNomineesDTO"] =
          ERPUtils.isUndefinedOrNull(selectedRoundData.empGratuityNomineesDTO) === false
            ? selectedRoundData.empGratuityNomineesDTO
            : SelectedFormState.empGratuityNomineesDTO;
      }
    }
    // if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.empPfNomineesDTO) === false) {
    //   oldObj["empPfNomineesDTO"] =
    //     ERPUtils.isUndefinedOrNull(selectedRoundData.empPfNomineesDTO) === false ? selectedRoundData.empPfNomineesDTO : SelectedFormState.empPfNomineesDTO;
    // }
    if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.empPfNomineesDTO) === false) {
      if (selectedRoundData.empPfNomineesDTO.length > 0) {
        oldObj = mapPfDetails(oldObj, selectedRoundData.empPfNomineesDTO);
        oldObj["empPfNomineesDTO"] =
          ERPUtils.isUndefinedOrNull(selectedRoundData.empPfNomineesDTO) === false ? selectedRoundData.empPfNomineesDTO : SelectedFormState.empPfNomineesDTO;
      }
    }
    //****Family Dependent Details****//
    if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false) {
      const tempArray = [];
      tempArray.push({
        empFamilyDetailsAddtnlId: "",
        empApplnPersonalDataId: selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId,
        empPersonalDataId: "",
        relationship: "FATHER",
        dependentName: "",
        dependentDob: "",
        dependentQualification: "",
        dependentProfession: "",
        dependDOB: null,
      },
        {
          empFamilyDetailsAddtnlId: "",
          empApplnPersonalDataId: selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId,
          empPersonalDataId: "",
          relationship: "MOTHER",
          dependentName: "",
          dependentDob: "",
          dependentQualification: "",
          dependentProfession: "",
          dependDOB: null,
        },);
      if (ERPUtils.isUndefinedOrNull(selectedRoundData.familyDetailsAddtnlList) === false && selectedRoundData.familyDetailsAddtnlList.length > 0) {
        oldObj = mapFamilyDetails(oldObj, selectedRoundData.familyDetailsAddtnlList);
        oldObj["familyDetailsAddtnlList"] = !ERPUtils.isUndefinedOrNull(selectedRoundData.familyDetailsAddtnlList)
          ? selectedRoundData.familyDetailsAddtnlList
          : SelectedFormState.familyDetailsAddtnlList;
      } else {
        if (!ERPUtils.isNullorWhiteSpace(selectedRoundData.maritalStatusDTO)) {
          if (selectedRoundData?.maritalStatusDTO?.label === "Married") {
            tempArray.push({
              empFamilyDetailsAddtnlId: "",
              empApplnPersonalDataId: selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId,
              empPersonalDataId: "",
              relationship: "SPOUSE",
              dependentName: "",
              dependentDob: "",
              dependentQualification: "",
              dependentProfession: "",
              dependDOB: null,
            });
          }
        };
        oldObj["familyDetailsAddtnlList"] = tempArray;
      }
    }

    if (ERPUtils.isUndefinedOrNull(selectedRoundData) === false && ERPUtils.isUndefinedOrNull(selectedRoundData.dependentDetailsAddtnlList) === false) {
      if (selectedRoundData.dependentDetailsAddtnlList.length > 0) {
        oldObj = mapDependantDetails(oldObj, selectedRoundData.dependentDetailsAddtnlList);
        oldObj["dependentDetailsAddtnlList"] = !ERPUtils.isUndefinedOrNull(selectedRoundData.dependentDetailsAddtnlList)
          ? selectedRoundData.dependentDetailsAddtnlList
          : SelectedFormState.dependentDetailsAddtnlList;
      }
    }

    AddReqErrorsForSaveDrftData(oldObj);
  };

  const AddReqErrorsForSaveDrftData = (oldObj) => {
    let reqErrors = { ...RequiredFields };
    if (addReqErrors.tenth.length > 0) {
      addReqErrors.tenth.map((el, index) => {
        if (index > 0) {
          reqErrors["tenthReq"].push({
            TenthStateError: false,
            TenthCountryError: false,
          });
        }
        return "";
      });
    }
    if (addReqErrors.puc.length > 0) {
      addReqErrors.puc.map((el, index) => {
        if (index > 0) {
          reqErrors["pucReq"].push({
            PucStateError: false,
            PucCountryError: false,
          });
        }
        return "";
      });
    }
    if (addReqErrors.ug.length > 0) {
      addReqErrors.ug.map((el, index) => {
        if (index > 0) {
          reqErrors["ugReq"].push({
            UGStateError: false,
            UGCountryError: false,
          });
        }
        return "";
      });
    }
    if (addReqErrors.pg.length > 0) {
      addReqErrors.pg.map((el, index) => {
        if (index > 0) {
          reqErrors["pgReq"].push({
            PGStateError: false,
            PGCountryError: false,
          });
        }
        return "";
      });
    }
    if (addReqErrors.mphil.length > 0) {
      addReqErrors.mphil.map((el, index) => {
        if (index > 0) {
          reqErrors["mphilReq"].push({
            MphilStateError: false,
            MphilCountryError: false,
          });
        }
        return "";
      });
    }
    if (addReqErrors.phd.length > 0) {
      addReqErrors.phd.map((el, index) => {
        if (index > 0) {
          reqErrors["phdReq"].push({
            PhdStateError: false,
            PhdCountryError: false,
          });
        }
        return "";
      });
    }
    if (addReqErrors.others.length > 0) {
      addReqErrors.others.map((el, index) => {
        if (index > 0) {
          reqErrors["othersReq"].push({
            otherStateError: false,
            otherCountryError: false,
          });
        }
        return "";
      });
    }
    setRequiredFields(reqErrors, () => {
      setSelectedFormState(oldObj);
    });
  };

  // Save Api Handlers to frame the data:
  // Image Handler:

  // const frameImagesData = () => {
  //   let EducationDataImages = new FormData();
  //   //SHOULD BE CHANGED
  //   SelectedFormState["AdditonalEducationDetails"]?.Tenth?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Tenth_" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SelectedFormState["AdditonalEducationDetails"]?.Puc?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Puc_" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SelectedFormState["AdditonalEducationDetails"]?.UG?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Ug" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SelectedFormState["AdditonalEducationDetails"]?.PG?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Pg_" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SelectedFormState["AdditonalEducationDetails"]?.Mphil?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Mphil_" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SelectedFormState["AdditonalEducationDetails"]?.Phd?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Phd_" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SelectedFormState["AdditonalEducationDetails"]?.others?.map((el) => {
  //     el.documentList.map((item) => {
  //       EducationDataImages.append("files", item.file, "Others_" + item.fileName + "." + item.extension);
  //       return "";
  //     });
  //     return "";
  //   });
  //   SendUploadImagesToApi(EducationDataImages);
  // };

  // To set the upload api response to the state:
  // const mapHashvalue = (data) => {
  //   const oldObj = { ...SelectedFormState };

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].Tenth.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].Tenth[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].Puc.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].Puc[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].UG.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].UG[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].PG.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].PG[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].Mphil.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].Mphil[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].Phd.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].Phd[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   if (data.educationImgData !== "") {
  //     data.educationImgData.map((el) => {
  //       oldObj["AdditonalEducationDetails"].others.map((item, idx) => {
  //         item.documentList.map((innerItem, id) => {
  //           if (innerItem.fileName + "." + innerItem.extension === el.t1) {
  //             oldObj["AdditonalEducationDetails"].others[idx].documentList[id].fileName = el.t2;
  //           }
  //           return "";
  //         });
  //         return "";
  //       });
  //       return "";
  //     });
  //   }

  //   setSelectedFormState(oldObj, () => {
  //     FrameTheApiData();
  //   });
  // };

  // To frame the images data to save object:
  // const mapImageData = (data, type) => {
  // 	const newArray = [];
  // 	if (type === 'education') {
  // 		data.map((el) => {
  // 			var obj = {
  // 				empApplnEducationalDetailsDocumentsId:
  // 					el.empApplnEducationalDetailsDocumentsId !== undefined
  // 						? el.empApplnEducationalDetailsDocumentsId
  // 						: null,
  // 				empApplnEducationalDetailsId:
  // 					el.empApplnEducationalDetailsId !== undefined ? el.empApplnEducationalDetailsId : null,
  // 				educationalDocumentsUrl: el.fileName
  // 			};
  // 			newArray.push(obj);
  // 			return '';
  // 		});
  // 	}
  // 	return newArray;
  // };

  // To frame the api data object:
  const FrameTheApiData = () => {
    let EducationDataList = [];
    let OtherEducationDataList = [];
    let personalData = null;
    let jobDetailsData = null;
    let familyDependentDetails = [];
    let dependentDetails = [];
    let maritalStatusDTO = "";

    // Educational details
    EducationDataList = SelectedFormState?.AdditonalEducationDetails?.qualificationList || [];
    OtherEducationDataList = SelectedFormState?.AdditonalEducationDetails?.others || [];
    // Marital status
    maritalStatusDTO = SelectedFormState?.MaritalStatus || "";
    //**** Family dependent Details ***//
    familyDependentDetails = SelectedFormState?.familyDetailsAddtnlList || [];


    SelectedFormState.dependentDetailsAddtnlList.map((el) => {
      if (
        !ERPUtils.isNullorWhiteSpace(el.relationship) ||
        !ERPUtils.isNullorWhiteSpace(el.dependentName) ||
        !ERPUtils.isNullorWhiteSpace(el.dependDOB) ||
        !ERPUtils.isNullorWhiteSpace(SelectedFormState.familyDetailsAddtnlList[2]?.dependentProfession)
      ) {
        dependentDetails.push({
          relationship: !ERPUtils.isNullorWhiteSpace(el.relationship) ? el.relationship : null,
          empApplnPersonalDataId: !ERPUtils.isNullorWhiteSpace(el.empApplnPersonalDataId)
            ? selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId
            : null,
          empPersonalDataId: !ERPUtils.isNullorWhiteSpace(el.empPersonalDataId) ? el.empPersonalDataId : null,
          dependentName: ERPUtils.isNullorWhiteSpace(el.dependentName) === false ? el.dependentName : null,
          dependDOB: ERPUtils.isNullorWhiteSpace(el.dependDOB) === false ? el.dependDOB : null,
        });

      }
      return "";
    });

    // PersonalData Details:
    if (
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgContactName) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgContactAddress) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgContactRelationship) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgMobileNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgHomeContact) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgWorkContact) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportIssuedDate) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportStatus) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportDateOfExpiry) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportComments) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.visaNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.vissaIssuedDate) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.vissaStatus) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.visaDateOfExpiry) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.visaComments) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.PanNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.FourWheelerNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.TwoWheelerNO) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.familyBackgrounnd) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.haveAadhar) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.AadharNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EnrolledForAadhar) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.EnrollmentId) === false
    ) {
      personalData = {
        empAddtnlPersonalDataId:
          ERPUtils.isNullorWhiteSpace(selectedRoundData.additionalPersonalDataDTO.empAddtnlPersonalDataId) === false
            ? selectedRoundData.additionalPersonalDataDTO.empAddtnlPersonalDataId
            : null,
        empApplnPersonalDataId:
          ERPUtils.isNullorWhiteSpace(selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId) === false
            ? selectedRoundData.additionalPersonalDataDTO.empApplnPersonalDataId
            : null,
        emergencyContactName: ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgContactName) === false ? SelectedFormState.EmgContactName : null,
        emergencyContactAddress: ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgContactAddress) === false ? SelectedFormState.EmgContactAddress : null,
        emergencyContactRelatonship:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgContactRelationship) === false ? SelectedFormState.EmgContactRelationship : null,
        emergencyMobileNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgMobileNo) === false ? SelectedFormState.EmgMobileNo : null,
        emergencyContactHome: ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgHomeContact) === false ? SelectedFormState.EmgHomeContact : null,
        emergencyContactWork: ERPUtils.isNullorWhiteSpace(SelectedFormState.EmgWorkContact) === false ? SelectedFormState.EmgWorkContact : null,

        passportNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportNo) === false ? SelectedFormState.PassportNo : null,
        passportIssuedDate:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportIssuedDate) === false ? ERPUtils.validateDate(SelectedFormState.PassportIssuedDate) : null,
        passportStatus: ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportStatus) === false ? SelectedFormState.PassportStatus : null,
        passportDateOfExpiry:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportDateOfExpiry) === false ? ERPUtils.validateDate(SelectedFormState.PassportDateOfExpiry) : null,
        passportComments: ERPUtils.isNullorWhiteSpace(SelectedFormState.PassportComments) === false ? SelectedFormState.PassportComments : null,

        visaNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.visaNo) === false ? SelectedFormState.visaNo : null,
        visaIssuedDate:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.vissaIssuedDate) === false ? ERPUtils.validateDate(SelectedFormState.vissaIssuedDate) : null,
        visaStatus: ERPUtils.isNullorWhiteSpace(SelectedFormState.vissaStatus) === false ? SelectedFormState.vissaStatus : null,
        visaDateOfExpiry:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.visaDateOfExpiry) === false ? ERPUtils.validateDate(SelectedFormState.visaDateOfExpiry) : null,
        visaComments: ERPUtils.isNullorWhiteSpace(SelectedFormState.visaComments) === false ? SelectedFormState.visaComments : null,

        panNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.PanNo) === false ? SelectedFormState.PanNo : null,
        fourWheelerNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.FourWheelerNo) === false ? SelectedFormState.FourWheelerNo : null,
        twoWheelerNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.TwoWheelerNO) === false ? SelectedFormState.TwoWheelerNO : null,

        familyBackgroundBrief: ERPUtils.isNullorWhiteSpace(SelectedFormState.familyBackgrounnd) === false ? SelectedFormState.familyBackgrounnd : null,
        isAadharAvailable: ERPUtils.isNullorWhiteSpace(SelectedFormState.haveAadhar) === false ? SelectedFormState.haveAadhar : null,
        aadharNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.AadharNo) === false ? SelectedFormState.AadharNo : null,
        isAadharEnrolled: ERPUtils.isNullorWhiteSpace(SelectedFormState.EnrolledForAadhar) === false ? SelectedFormState.EnrolledForAadhar : null,
        aadharEnrolledNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.EnrollmentId) === false ? SelectedFormState.EnrollmentId : null,
      };
    } else {
      personalData = null;
    }
    // jobDetails:
    if (
      ERPUtils.isNullorWhiteSpace(SelectedFormState.UanNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.pfAccountNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.pfDate) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.AccountWithSib) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.AcctNO) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.IfscCode) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.gratuityNo) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.gratuityDate) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.confirmJoiningDate) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.preferedJoiningDateTime) === false ||
      ERPUtils.isNullorWhiteSpace(SelectedFormState.joiningDateRejectReason) === false
    ) {
      jobDetailsData = {
        empJobDetailsId:
          ERPUtils.isNullorWhiteSpace(selectedRoundData.empJobDetailsDTO.empJobDetailsId) === false ? selectedRoundData.empJobDetailsDTO.empJobDetailsId : null,
        empApplnEntriesId:
          ERPUtils.isNullorWhiteSpace(selectedRoundData.empJobDetailsDTO.empApplnEntriesId) === false
            ? selectedRoundData.empJobDetailsDTO.empApplnEntriesId
            : ActiveInterviewRound.empApplnEntriesId || null,
        uanNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.UanNo) === false ? SelectedFormState.UanNo : null,
        pfAccountNo:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.pfAccountNo) === false ? SelectedFormState.empJobDetailsDTO.pfAccountNo : null,
        pfDate: ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.pfDate) === false ? SelectedFormState.empJobDetailsDTO.pfDate : null,
        gratuityNo: ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.gratuityNo) === false ? SelectedFormState.empJobDetailsDTO.gratuityNo : null,
        gratuityDate:
          ERPUtils.isNullorWhiteSpace(SelectedFormState.empJobDetailsDTO.gratuityDate) === false ? SelectedFormState.empJobDetailsDTO.gratuityDate : null,
        isSibAccountAvailable: ERPUtils.isNullorWhiteSpace(SelectedFormState.AccountWithSib) === false ? SelectedFormState.AccountWithSib : null,
        sibAccountBank: ERPUtils.isNullorWhiteSpace(SelectedFormState.AcctNO) === false ? SelectedFormState.AcctNO : null,
        ifscCode: ERPUtils.isNullorWhiteSpace(SelectedFormState.IfscCode) === false ? SelectedFormState.IfscCode : null,
        isJoiningDateConfirmed: ERPUtils.isNullorWhiteSpace(SelectedFormState.confirmJoiningDate) === false
          ? SelectedFormState.confirmJoiningDate : null,
        preferedJoiningDateTime: ERPUtils.isNullorWhiteSpace(SelectedFormState.preferedJoiningDateTime) === false ? SelectedFormState.preferedJoiningDateTime : null,
        joiningDateRejectReason: ERPUtils.isNullorWhiteSpace(SelectedFormState.joiningDateRejectReason) === false ? SelectedFormState.joiningDateRejectReason : null,
      };
    } else {
      jobDetailsData = null;
    }

    CallSaveApi(EducationDataList, OtherEducationDataList, personalData, jobDetailsData, familyDependentDetails, dependentDetails, maritalStatusDTO);

    return "";
  };

  // Api Calls:

  // To get the un availability reasons dropdown data:
  const ReasonsApi = () => {
    setLoaderActive(true);
    let url = "Employee/CommonEmployee/getApplnNonAvailability?interviewRound=";
    let interviewRound = "selected";
    ApiGateway.post(url + interviewRound, {}, (response) => {
      try {
        setLoaderActive(false);
        if (ERPUtils.isUndefinedOrNull(response) === false) {
          try {
            if (response.status === "SUCCESS") {
              let newArray = [];
              response.data.dto.filter((el) => {
                if (el.isFinalSelection === "true") {
                  newArray.push(el);
                }
                return "";
              });
              newArray.push({ value: "Other", label: "Other" });
              setReasonsForRej(newArray);
            } else {
              setLoaderActive(false);
            }
          } catch (ex) { }
        }
      } catch (ex) {
        setLoaderActive(false);
      }
    });
  };

  // To get the dropdowns data
  const EducationDetailsApi = () => {
    setLoaderActive(true);
    ApiGateway.getBuilder()
      .addPost("Common/getState", {})
      .addPost("Common/getCountryAndNationality", {})
      .addPost("Common/getQualificationLevel", {})
      .addPost("Common/getMaritalStatus", {})
      .execute((responses) => {
        try {
          setLoaderActive(false);
          let States = [];
          let Countries = [];
          if (ERPUtils.isUndefinedOrNull(responses) === false && ERPUtils.isUndefinedOrNull(responses.length) === false) {
            if (responses.length > 0) {
              try {
                States = responses[0].data || [];
                States.dto.push({ value: "Others", label: "Others" });
                Countries = responses[1].data || [];
                Countries.dto.push({ value: "Others", label: "Others" });
              } catch (ex) { }
            }
          } else {
          }
          setStates(States.dto);
          setCountries(Countries.dto);
          setMartialOptions(responses[3].data.dto);
          setQualificationData(responses[2].data.dto, () => {
            FrameEducationData([States.dto, Countries.dto, responses[2].data.dto]);
          });
        } catch (ex) {
          setLoaderActive(false);
        }
      });
  };

  // Upload Api:
  // const SendUploadImagesToApi = (Education) => {
  //   let oldData = {
  //     educationImgData: "",
  //   };
  //   if (Education.getAll("files").length > 0) {
  //     ApiGateway.postFiles("Employee/Recruitment/EmployeeApplicationControler/educationalDetailsFilesUpload", Education, (response) => {
  //       setLoaderActive(false);
  //       if (response.status === "SUCCESS") {
  //         oldData["educationImgData"] = response.data.dto;
  //         mapHashvalue(oldData);
  //       } else {
  //         setLoaderActive(false);
  //         alert("Error");
  //       }
  //     });
  //   } else {
  //     setLoaderActive(false);
  //     mapHashvalue(oldData);
  //   }
  // };

  // Save Api:

  const CallSaveApi = (EducationData, OtherEducationData, personalData, jobDetailsData, familyDependentDetails, dependentDetails, maritalStatusDTO) => {
    if (SelectedFormState.empGratuityNomineesDTO) {
      SelectedFormState.empGratuityNomineesDTO.forEach((nominee) => {
        nominee.isGratuity = true;
        nominee.isPf = false;
      });
    }
    if (SelectedFormState.empPfNomineesDTO) {
      SelectedFormState.empPfNomineesDTO.forEach((nominee) => {
        nominee.isPf = true;
        nominee.isGratuity = false;
      });
    }
    const gratuityDTO = []
    SelectedFormState.empGratuityNomineesDTO.map((data) => {
      if (
        !ERPUtils.isNullorWhiteSpace(data.nominee) ||
        !ERPUtils.isNullorWhiteSpace(data.nomineeAddress) ||
        !ERPUtils.isNullorWhiteSpace(data.nomineesDob) ||
        !ERPUtils.isNullorWhiteSpace(data.nomineeRelationship) ||
        !ERPUtils.isNullorWhiteSpace(data.sharePercentage) ||
        !ERPUtils.isNullorWhiteSpace(data.under18GuardName) ||
        !ERPUtils.isNullorWhiteSpace(data.under18GuardianAddress)
      ) {
        gratuityDTO.push(data)
      }
      return gratuityDTO
    })

    const nomineeDTO = []
    SelectedFormState.empPfNomineesDTO.map((data) => {
      if (
        !ERPUtils.isNullorWhiteSpace(data.nominee) ||
        !ERPUtils.isNullorWhiteSpace(data.nomineeAddress) ||
        !ERPUtils.isNullorWhiteSpace(data.nomineesDob) ||
        !ERPUtils.isNullorWhiteSpace(data.nomineeRelationship) ||
        !ERPUtils.isNullorWhiteSpace(data.sharePercentage) ||
        !ERPUtils.isNullorWhiteSpace(data.under18GuardName) ||
        !ERPUtils.isNullorWhiteSpace(data.under18GuardianAddress)
      ) {
        nomineeDTO.push(data)
      }
      return nomineeDTO
    })
    const ApiData = {
      interviewRound: "selected",
      empApplnEntriesId: ERPUtils.isNullorWhiteSpace(ActiveInterviewRound.empApplnEntriesId) === false ? ActiveInterviewRound.empApplnEntriesId : null,
      isAcceptOffer: ERPUtils.isNullorWhiteSpace(SelectedFormState.OfferLetterAcceptence) === false ? SelectedFormState.OfferLetterAcceptence : null,
      empApplnNonAvailabilityDTO:
        ERPUtils.isNullorWhiteSpace(SelectedFormState.OfferLetterAcceptence) === false
          ? SelectedFormState.OfferLetterAcceptence === "true"
            ? null
            : ERPUtils.isNullorWhiteSpace(SelectedFormState.RejectionReason.label) === false
              ? SelectedFormState.RejectionReason.label === "Other"
                ? {
                  empApplnNonAvailabilityId: null,
                  nonAvailabilityName: SelectedFormState.otherReason,
                  isReschedulable: null,
                  interviewRound: null,
                  isFinalSelection: true,
                }
                : {
                  empApplnNonAvailabilityId: SelectedFormState.RejectionReason.value,
                  nonAvailabilityName: SelectedFormState.RejectionReason.label,
                  isReschedulable: SelectedFormState.RejectionReason.isReschedulable,
                  interviewRound: null,
                  isFinalSelection: SelectedFormState.RejectionReason.isFinalSelection,
                }
              : null
          : null,
      reportingDate: ERPUtils.isNullorWhiteSpace(SelectedFormState.ReportingDate) === false ? SelectedFormState.ReportingDate : null,
      // ************************

      JoiningDate: ERPUtils.isNullorWhiteSpace(SelectedFormState.JoiningDate) === false ? SelectedFormState.JoiningDate : null,

      // **********************************

      educationalDetailDTO: {
        highestQualificationLevelId:
          ERPUtils.isNullorWhiteSpace(selectedRoundData.educationalDetailDTO.highestQualificationLevelId) === false
            ? selectedRoundData.educationalDetailDTO.highestQualificationLevelId
            : null,
        qualificationLevelsList: EducationData.length > 0 ? EducationData : null,
        otherQualificationLevelsList: OtherEducationData.length > 0 ? OtherEducationData : null,
      },

      additionalPersonalDataDTO: personalData,
      empJobDetailsDTO: jobDetailsData,

      empGratuityNomineesDTO: gratuityDTO,
      empPfNomineesDTO: nomineeDTO,
      maritalStatusDTO: { label: maritalStatusDTO?.label, value: maritalStatusDTO?.value },
      familyDetailsAddtnlList: familyDependentDetails || [],
      dependentDetailsAddtnlList: dependentDetails || [],
    };
    let validFlag = true;
    // if ((SelectedFormState.TermsAndConditions || SelectedFormState?.OfferLetterAcceptence==="false") && 
    // (SelectedFormState.preferedJoiningDateTime || SelectedFormState?.confirmJoiningDate === "true") &&
    // (SelectedFormState.joiningDateRejectReason  || SelectedFormState?.confirmJoiningDate === "true")) {
    //   validFlag = true;
    // } else {
    //   validFlag = false;

    //   $("#joiningDateReason").addClass("text-danger")
    //   $("#preferedJoiningDate").addClass("text-danger")
    // }
    if (SelectedFormState?.OfferLetterAcceptence === "true") {
      if (!SelectedFormState.TermsAndConditions) {
        validFlag = false;
        $("#termsAndConditionText").addClass("text-danger")
      } else {
        $("#termsAndConditionText").removeClass("text-danger")
        validFlag = true;
      }
      if (ERPUtils.isNullorWhiteSpace(SelectedFormState.confirmJoiningDate)) {
        validFlag = false;
        $("#confirmJoinDate").addClass("text-danger")
      } else $("#confirmJoinDate").removeClass("text-danger")

      if (SelectedFormState.confirmJoiningDate === "false") {
        if (ERPUtils.isNullorWhiteSpace(SelectedFormState.preferedJoiningDateTime)) {
          validFlag = false;
          $("#preferedJoiningDate").addClass("text-danger")
        } else {
          $("#preferedJoiningDate").removeClass("text-danger")
          validFlag = true;
        }
        if (ERPUtils.isNullorWhiteSpace(SelectedFormState.joiningDateRejectReason)) {
          validFlag = false;
          $("#joiningDateReason").addClass("text-danger")
        } else {
          $("#joiningDateReason").removeClass("text-danger")
          validFlag = true;
        }
      }
    }
    if (validFlag) {
      setLoaderActive(true);
      let url = "Employee/Recruitment/EmployeeApplicationControler/submitEmployeeApplicationInterviewDetails";
      ApiGateway.post(url, ApiData, (response) => {
        try {
          setLoaderActive(false);
          if (ERPUtils.isUndefinedOrNull(response) === false) {
            try {
              if (response.status === "SUCCESS") {
                toast.success("Data Submitted Successfully")
                getApplicationsData();
              } else {
                setLoaderActive(false);
                setErrorMsg("Data Submission failed ! . Please try again later.");
                AlertError();
              }
            } catch (ex) { }
          } else {
            setErrorMsg("Data Submission failed ! , Please try again later.");
            AlertError();
          }
        } catch (ex) {
          setLoaderActive(false);
        }
      });
    } else {
      if (!SelectedFormState.TermsAndConditions && SelectedFormState?.OfferLetterAcceptence === "true") {
        toast.warn("Please accept the terms and condition before submitting");
      }
    }
  };


  const CloseErrorPopup = (target) => {
    if (target === "AccountError") {
      setAccountErrorPopup(false);
    }
    if (target === "validationAlert") {
      setValidationAlert(false);
    }
    if (target === "RequiredFieldsAlert") {
      setRequiredFieldAlert(false);
    }
  };

  const ConfirmAcctNo = () => {
    if (ERPUtils.isNullorWhiteSpace(SelectedFormState.AcctNO) === false) {
      if (!(SelectedFormState.AcctNO === SelectedFormState.ConfirmAcctNo) && SelectedFormState.AccountWithSib === "true") {
        setAccountErrorPopup(true);
        setAcctNumError(true);
      } else {
        CheckRequiredErrors();
      }
    } else {
      CheckRequiredErrors();
    }
  };

  const checkForValidationErrors = () => {
    const CheckValidationErrorsData = { ...validationErrors };
    let validationErrorsFound = [];
    Object.keys(CheckValidationErrorsData).map((el) => {
      validationErrorsFound.push(validationErrors[el]);
      return "";
    });
    if (validationErrorsFound.indexOf(true) !== -1) {
      setValidationAlert(true);
    } else {
      ConfirmAcctNo();
    }
    return "";
  };

  const CheckRequiredErrors = () => {
    const checkThese = ["OfferLetterAcceptence"];
    const ReqErrors = { ...RequiredFields };
    const available = {
      RejectionReason: SelectedFormState.OfferLetterAcceptence !== "" ? (SelectedFormState.OfferLetterAcceptence === "false" ? true : false) : false,
      otherReason: SelectedFormState.OfferLetterAcceptence !== "" ? (SelectedFormState.RejectionReason.label === "Other" ? true : false) : false,
      AcctNO: SelectedFormState.AccountWithSib === "true" ? true : false,
      IfscCode: SelectedFormState.AccountWithSib === "true" ? true : false,
    };

    checkThese.map((el) => {
      if (
        ERPUtils.isUndefinedOrNull(SelectedFormState[el]) === true ||
        ERPUtils.isNullOrEmpty(SelectedFormState[el]) === true ||
        ERPUtils.isNullorWhiteSpace(SelectedFormState[el]) === true
      ) {
        let name = el + "ReqError";
        ReqErrors.commonErrors[0][name] = true;
      } else {
        let name = el + "ReqError";
        ReqErrors.commonErrors[0][name] = false;
      }
      return "";
    });

    Object.keys(available).map((el) => {
      if (available[el]) {
        if (
          ERPUtils.isUndefinedOrNull(SelectedFormState[el]) === true ||
          ERPUtils.isNullOrEmpty(SelectedFormState[el]) === true ||
          ERPUtils.isNullorWhiteSpace(SelectedFormState[el]) === true
        ) {
          let name = el + "ReqError";
          ReqErrors.commonErrors[0][name] = true;
        } else {
          let name = el + "ReqError";
          ReqErrors.commonErrors[0][name] = false;
        }
      } else {
        let name = el + "ReqError";
        ReqErrors.commonErrors[0][name] = false;
      }
      return "";
    });
    setRequiredFields(ReqErrors, () => {
      CheckForErrors(ReqErrors);
    });
  };

  // Handler to remove the Required field Error messages:
  const RemoveReqFieldErrors = (target, header, id) => {
    let removeReqErrors = { ...RequiredFields };
    const checkError = target + "ReqError";
    if (target === "AccountWithSib") {
      removeReqErrors.commonErrors[0]["AcctNOReqError"] = false;
      removeReqErrors.commonErrors[0]["IfscCodeReqError"] = false;
      setAcctNumError(false);
    }
    if (removeReqErrors.commonErrors[0][checkError]) {
      removeReqErrors.commonErrors[0][checkError] = false;
    }
    setRequiredFields(removeReqErrors);
    return "";
  };

  const CheckForErrors = () => {
    var allVals = [];
    Object.keys(RequiredFields).map((el) => {
      RequiredFields[el].map((item, index) => {
        Object.keys(item).map((innerItem) => {
          allVals.push(RequiredFields[el][index][innerItem]);
          return "";
        });
        return "";
      });
      return "";
    });
    if (allVals.indexOf(true) !== -1) {
      setRequiredFieldAlert(true);
    } else {
      // frameImagesData();
      FrameTheApiData();
    }
    return "";
  };

  const downloadOfferLetter = () => {
    const dowloadPresigned = selectedRoundData.offerLetterfileUploadDownloadDTO;
    const codeForProcess = dowloadPresigned.processCode;
    const pathUrl = dowloadPresigned.actualPath;
    const ogFileName = dowloadPresigned.originalFileName;
    ERPUtils.getPresignedUrlDownload(pathUrl, codeForProcess, ogFileName);
  };

  const onSubmit = () => {
    checkForValidationErrors();
    // FrameTheApiData();
  };

  React.useEffect(() => {
    EducationDetailsApi();
    ReasonsApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div style={{ maxHeight: "500px", minHeight: "300px", overflowY: "auto", width: "100%" }}>
        <div className="parentBoxDiv">
          <div className="row">

            <div className="col-md-3">
              <label className="formExpLabel">Joining Date:</label>
              <div style={{ fontSize: "13px" }}>{SelectedFormState.JoiningDate || "NA"}</div>
            </div>
            <div className="col-md-3">
              <label className="formExpLabel">Accept the offer </label>
              <div className="">
                <label className="radio-inline">
                  <input
                    className="space"
                    onChange={onChangeHandler}
                    type="radio"
                    name="OfferLetterAcceptence"
                    value="true"
                    checked={SelectedFormState.OfferLetterAcceptence === "true"}
                    disabled={interviewDetails?.editable === false ? true : false}
                  />
                  Yes
                </label>
                <label className="radio-inline">
                  <input
                    className="space"
                    onChange={onChangeHandler}
                    type="radio"
                    name="OfferLetterAcceptence"
                    value="false"
                    checked={SelectedFormState.OfferLetterAcceptence === "false"}
                    disabled={interviewDetails?.editable === false ? true : false}
                  />
                  No
                </label>
              </div>
            </div>
            {!ERPUtils.isNullorWhiteSpace(selectedRoundData.offerLetterfileUploadDownloadDTO) || !ERPUtils.isUndefinedOrNull(selectedRoundData.offerLetterfileUploadDownloadDTO) ? (
              <div className="col-md-6 d-flex align-items-center justify-content-center">
                <button className="btn btn-primary" onClick={downloadOfferLetter}>
                  Download Offer Letter
                </button>
              </div>
            ) : null}
          </div>
          <div className="row" style={{ paddingLeft: "2px" }}>
            {ERPUtils.isUndefinedOrNull(SelectedFormState.OfferLetterAcceptence) || SelectedFormState.OfferLetterAcceptence !== "false" ? (
              <div className="col-md-3">
                <label className="formExpLabel" id="confirmJoinDate"><span className="requiredText">* </span> Confirm Your joining date </label>
                <div>
                  <label className="radio-inline">
                    <input
                      className="space"
                      onChange={onChangeHandler}
                      type="radio"
                      name="confirmJoiningDate"
                      value="true"
                      checked={SelectedFormState.confirmJoiningDate === "true" || SelectedFormState.confirmJoiningDate === true}
                      disabled={SelectedFormState.OfferLetterAcceptence !== "true" || interviewDetails?.editable === false}
                    />
                    Yes
                  </label>
                  <label className="radio-inline">
                    <input
                      className="space"
                      onChange={onChangeHandler}
                      type="radio"
                      name="confirmJoiningDate"
                      value="false"
                      checked={SelectedFormState.confirmJoiningDate === "false" || SelectedFormState.confirmJoiningDate === false}
                      disabled={SelectedFormState.OfferLetterAcceptence !== "true" || interviewDetails?.editable === false}
                    />
                    No
                  </label>
                </div>
              </div>) : ""}

            {SelectedFormState.confirmJoiningDate === "false" || SelectedFormState.confirmJoiningDate === false ? (
              <>
                {SelectedFormState.OfferLetterAcceptence === "true" || SelectedFormState.OfferLetterAcceptence === true ? (
                  <>
                    <div className="col-md-4">
                      <label className="formExpLabel " id="preferedJoiningDate">
                        <span className="requiredText">* </span>
                        Preferred joining date:
                      </label>
                      <div style={{ width: "70%" }}>
                        <DatePicker
                          onChange={(date) =>
                            DateChangeHandler(date, 'preferedJoiningDateTime', null, null)}
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="dd-MMM-yyyy HH:mm"
                          timeFormat={'HH:mm'}
                          showTimeSelect
                          dropdownMode="select"
                          autoComplete="off"
                          placeholderText="DD-MMM-YYYY HH:MM"
                          timeIntervals={30}
                          isClearable
                          className="form-control"
                          onFocus={e => e.target.blur()}
                          selected={Utils.convertLocalDateToDateObj(SelectedFormState.preferedJoiningDateTime)}
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label className="formExpLabel " id="joiningDateReason">
                        <span className="requiredText">* </span>
                        Reason for change in joining date:
                      </label>
                      <textarea
                        className="form-control z-depth-3"
                        rows="5"
                        name="joiningDateRejectReason"
                        maxLength={200}
                        onChange={onChangeHandler}
                        value={SelectedFormState.joiningDateRejectReason || ""}
                        disabled={interviewDetails.editable === false ? true : false}
                        style={{ height: "50%" }}
                      />
                      <div style={{ textAlign: "end" }}>

                        {SelectedFormState.joiningDateRejectReason?.length} / 200
                      </div>
                    </div>
                  </>
                ) : null}
              </>
            ) : null}
          </div>
          {SelectedFormState.OfferLetterAcceptence === "true" ? (
            <div>
              {interviewDetails?.editable === false ? null : (
                <div>

                  <div className="row" style={{ paddingLeft: "2px" }}>
                    <div className="col pt-2">
                      <label id="termsandConditions">
                        <input
                          type="checkbox"
                          name="TermsAndConditions"
                          className="position-relative mr-1 ml-0"
                          onChange={CheckBoxHandler}
                          checked={SelectedFormState.TermsAndConditions}
                        />
                        <span className="mx-1" style={{ color: "#d9291b" }}>*</span>
                        <b style={{ color: "#666666", fontSize: "0.9rem", fontWeight: "600" }} id="termsAndConditionText">I Read and accept the terms and conditions in the offer letter</b>
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : null}
          {SelectedFormState.OfferLetterAcceptence === "false" ? (
            <div className="container">
              <div className="row pt-3">
                <div className="col-xs-12 col-md-4">
                  <label className="appFormLabel ">
                    <span className="requiredText">*</span>
                    Reasons for rejection
                  </label>
                </div>
                <div className="col-md-4 col-xs-12">
                  <Select
                    className="z-depth-3"
                    options={ReasonsForRej}
                    onChange={(selected) => selectHandler(selected, "RejectionReason")}
                    value={SelectedFormState.RejectionReason || ""}
                    isDisabled={interviewDetails?.editable === false ? true : false}
                    isClearable
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                    menuPortalTarget={document.body}
                  />
                  {RequiredFields.commonErrors[0]?.RejectionReasonReqError ? (
                    <p className="RoundValidationError">
                      <i className="fa fa-warning warningIcon" />
                      &nbsp; This field cannot be empty
                    </p>
                  ) : null}
                </div>
              </div>
              {SelectedFormState?.RejectionReason?.label === "Other" ? (
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <label className="appFormLabel ">
                      <span className="requiredText">*</span>
                      Other reason
                    </label>
                  </div>
                  <div className="col-md-4 col-xs-12">
                    <input
                      className="form-control"
                      name="otherReason"
                      value={SelectedFormState.otherReason}
                      onChange={onChangeHandler}
                      disabled={interviewDetails?.editable === false ? true : false}
                    />
                    {RequiredFields.commonErrors[0]?.otherReasonReqError ? (
                      <p className="RoundValidationError">
                        <i className="fa fa-warning warningIcon" />
                        &nbsp; This field cannot be empty
                      </p>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>

        {SelectedFormState.OfferLetterAcceptence === "true" ? (
          <div className="parentBoxDiv">
            <AdditionalDetailsPage
              dateHandlerString={dateHandlerString}
              dependentDetailsHandler={dependentDetailsHandler}
              familyDependentChangeHandler={familyDependentChangeHandler}
              selectedRoundData={selectedRoundData}
              qualificationData={qualificationData}
              SelectedFormState={SelectedFormState}
              setSelectedFormState={setSelectedFormState}
              EducationSelectHandler={EducationSelectHandler}
              onChangeHandler={onChangeHandler}
              NomineeDetailsHandler={NomineeDetailsHandler}
              countries={countries}
              states={states}
              MaritalOptions={MaritalOptions}
              selectHandler={selectHandler}
              AddMoreHandler={AddMoreHandler}
              RemoveHandler={RemoveHandler}
              interviewDetails={interviewDetails}
              DateChangeHandler={DateChangeHandler}
              onFileChange={onFileChange}
              openImageInTab={openImageInTab}
              imageRemoveHandler={imageRemoveHandler}
              validationErrors={validationErrors}
              acctNumError={acctNumError}
              RequiredFields={RequiredFields}
            />
          </div>
        ) : null}
      </div>
      {interviewDetails?.editable === false ? null : (
        <div className="border-top">
          <div className="row text-center  justify-content-center">
            <button className="myButton DashboardSubmitBtn z-depthButton m-1" value="Previous" name="PersonalDetails" onClick={onSubmit}>
              Save
            </button>
            <button className="myButton DashBoardCancel z-depthButton m-1" value="Save Draft" name="SaveDraft" onClick={closeInterviewModal}>
              Cancel
            </button>
          </div>
        </div>
      )}
      {LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
      {AccountErrorPopup ? (
        <Popup
          open={AccountErrorPopup}
          close={CloseErrorPopup}
          msg="Account Number does not match"
          title="Error!"
          icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
          success={false}
          tabName="AccountError"
        />
      ) : null}
      {ValidationAlert ? (
        <Popup
          open={ValidationAlert}
          close={CloseErrorPopup}
          msg="Hang on, You have few invalid error fields in the form"
          title="Sorry!"
          icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
          success={false}
          hint="Note: Please review you form and submit"
          tabName="validationAlert"
        />
      ) : null}
      {RequiredFieldAlert ? (
        <Popup
          open={RequiredFieldAlert}
          close={CloseErrorPopup}
          msg="Please check, Some of the required fields are missing in your application"
          title="Sorry!"
          icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
          success={false}
          hint="Note: Please review you form and submit"
          tabName="RequiredFieldsAlert"
        />
      ) : null}
      {ErrorPopup ? (
        <Popup
          open={ErrorPopup}
          close={ErrorPopupHandler}
          msg={ErrorMsg}
          icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
          title="Error!"
          success={false}
        />
      ) : null}
    </>
  );
};

export default SelectedForm;
